import * as types from '../mutation-types/editor-device-manager'

const namespaced = true
export const namespace = 'EditorDeviceManager'

// state
const state = {
    devices: [],
    currentDeviceId: null,
    viewWidth: null,
    viewHeight: null,
    viewScale: null,
    canvasWidth: null,
    canvasHeight: null,
    canvasOffset: null,
    canvasScroll: { left: 0, top: 0 },
    canvasMousePosition: null,
    builderMousePosition: null,
}

// mutations
const mutations = {
    [types.SET_ALL_DEVICES](s, { allDevices }) {
        s.devices = allDevices
    },
    [types.SET_CURRENT_DEVICE](s, device) {
        s.currentDeviceId = device.id
    },
    [types.SET_VIEW_SIZE](s, view) {
        s.viewWidth = view.width
        s.viewScale = view.scale
    },
    [types.SET_VIEW_SIZE_HEIGHT](s, height) {
        s.viewHeight = height
    },
    [types.SET_CANVAS_SIZE](s, size) {
        if (size.width !== undefined) {
            s.canvasWidth = size.width
        }
        if (size.height !== undefined) {
            s.canvasHeight = size.height
        }
    },
    [types.SET_CANVAS_OFFSET](s, offset) {
        s.canvasOffset = offset
    },
    [types.SET_CANVAS_SCROLL](s, scroll) {
        const o = { ...s.canvasScroll }
        if (scroll.left !== undefined) {
            o.left = scroll.left
        }
        if (scroll.top !== undefined) {
            o.top = scroll.top
        }
        s.canvasScroll = o
    },
    [types.SET_CANVAS_MOUSE_POSITION](s, position) {
        s.canvasMousePosition = position
    },
    [types.SET_BUILDER_MOUSE_POSITION](s, position) {
        s.builderMousePosition = position
    },
}

// actions
const actions = {
    setAllDevices({commit}, payload) {
        commit(types.SET_ALL_DEVICES, payload)
    },
    setCurrentDevice({commit}, payload) {
        commit(types.SET_CURRENT_DEVICE, payload)
    },
    setViewSize({commit}, payload) {
        commit(types.SET_VIEW_SIZE, payload)
    },
    setViewSizeHeight({commit}, payload) {
        commit(types.SET_VIEW_SIZE_HEIGHT, payload)
    },
    setCanvasSize({commit}, payload) {
        commit(types.SET_CANVAS_SIZE, payload)
    },
    setCanvasOffset({commit}, payload) {
        commit(types.SET_CANVAS_OFFSET, payload)
    },
    setCanvasScroll({commit}, payload) {
        commit(types.SET_CANVAS_SCROLL, payload)
    },
    setCanvasMousePosition({commit}, position) {
        commit(types.SET_CANVAS_MOUSE_POSITION, position)
    },
    setBuilderMousePosition({commit}, position) {
        commit(types.SET_BUILDER_MOUSE_POSITION, position)
    },
}

// getters
const getters = {
    allDevices: s => {
        return s.devices
    },
    largerDevices: s => {
        return s.devices.filter(d => d.mediaCondition == 'min-width')
    },
    smallerDevices: s => {
        return s.devices.filter(d => d.mediaCondition == 'max-width')
    },
    middleDevice: s => {
        return s.devices.find(d => !d.mediaCondition)
    },
    currentDevice: s => {
        return s.devices.find(d => d.id === s.currentDeviceId)
    },
    viewSize: s => {
        return {
            width: s.viewWidth,
            height: s.viewHeight,
            scale: s.viewScale,
        }
    },
    canvasSize: s => {
        return {
            width: s.canvasWidth,
            height: s.canvasHeight,
        }
    },
    canvasOffset: s => {
        return s.canvasOffset
    },
    canvasScroll: s => {
        return s.canvasScroll
    },
    canvasMousePosition: s => {
        return s.canvasMousePosition
    },
    builderMousePosition: s => {
        return s.builderMousePosition
    },
}

export default {namespaced, namespace, state, mutations, actions, getters}
